import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import i18n from 'i18n';
import Switch from '@material-ui/core/Switch';
import GenericForm from 'skyone-lib/lib/GenericForm';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import { ClientFields } from 'modules/clients/interfaces';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import { IconButton, Tooltip, makeStyles } from '@material-ui/core';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface ClientDUOConfigProps {
  setFieldValue: (key: string, value: unknown) => void;
  setDuoStatus: (status: boolean) => void;
  errors: any;
  clientSelected: ClientFields;
}

const ClientDUOConfig: React.FC<ClientDUOConfigProps> = ({
  setFieldValue,
  setDuoStatus,
  errors,
  clientSelected,
}) => {
  const classes = useStyles();
  const [secretPass, setSecretPass] = React.useState(false);
  const storePassword = React.useState(clientSelected.duo?.duo_client_secret);

  return (
    <>
      <Grid container data-testid={'autosky-clientduoconfig'}>
        <Typography className={classes.sectionTitle} variant="h4">
          {i18n.t('PARTNER_PAGE.DUO_KEY')}
        </Typography>
      </Grid>
      <Grid container className={classes.virtualizerSwitch}>
        <FormControlLabel
          className={classes.formLabel}
          control={
            <Switch
              id="toggle-use-duo"
              classes={{ colorSecondary: classes.switchChecked }}
              size="small"
              onChange={(_, checked) => {
                setFieldValue('duo.enabled', checked);
                setDuoStatus(checked);
              }}
              checked={clientSelected?.duo?.enabled}
              name="duo"
            />
          }
          label={
            <Typography className={classes.switchText}>
              {i18n.t('ACTIVE_DUO_DESCRIPTION_KEY')}
            </Typography>
          }
        />
      </Grid>
      {clientSelected?.duo?.enabled === true && (
        <Grid container className={classes.ssoContainer}>
          <Grid container spacing={2}>
            <GenericForm
              overrideClasses={{
                checkboxLabel: { fontSize: 12, fontWeight: 500 },
              }}
              errors={errors}
              fields={clientSelected}
              setFieldValue={setFieldValue}
              screenFields={[
                {
                  gridXs: 6,
                  label: i18n.t('DUO_CLIENT_ID'),
                  stateKey: 'duo.duo_client_id',
                  validateOnChange: true,
                },
              ]}
            />
            <Grid item xs={5} className={classes.clientSecretPassField}>
              {!secretPass && clientSelected.duo.duo_client_secret ? (
                <GenericForm
                  overrideClasses={{
                    checkboxLabel: { fontSize: 12, fontWeight: 500 },
                  }}
                  errors={errors}
                  fields={clientSelected}
                  setFieldValue={setFieldValue}
                  screenFields={[
                    {
                      gridXs: 12,
                      label: i18n.t('DUO_CLIENT_SECRET'),
                      stateKey: 'duo.duo_client_secret',
                      disabled: true,
                      isPassword: true,
                    },
                  ]}
                />
              ) : (
                <GenericForm
                  overrideClasses={{
                    checkboxLabel: { fontSize: 12, fontWeight: 500 },
                  }}
                  errors={errors}
                  fields={clientSelected}
                  setFieldValue={setFieldValue}
                  screenFields={[
                    {
                      gridXs: 12,
                      label: i18n.t('DUO_CLIENT_SECRET'),
                      stateKey: 'duo.duo_client_secret',
                    },
                  ]}
                />
              )}
            </Grid>
            <Grid item xs={1}>
              {secretPass ? (
                <Tooltip title={i18n.t('CANCEL_KEY')}>
                  <IconButton
                    onClick={() => {
                      setSecretPass(false);
                      setFieldValue('duo.duo_client_secret', storePassword);
                    }}
                    className={classes.changePassButton}
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip
                  title={i18n.t('PARTNER_PAGE.CHANGE_DUO_CLIENT_SECRET_KEY')}
                >
                  <IconButton
                    onClick={() => {
                      setSecretPass(true);
                      setFieldValue('duo.duo_client_secret', '');
                    }}
                    className={classes.changePassButton}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Grid>
            <GenericForm
              overrideClasses={{
                checkboxLabel: { fontSize: 12, fontWeight: 500 },
              }}
              errors={errors}
              fields={clientSelected}
              setFieldValue={setFieldValue}
              screenFields={[
                {
                  gridXs: 6,
                  label: i18n.t('HOST_KEY'),
                  stateKey: 'duo.host',
                  validateOnChange: true,
                },
              ]}
            />
            <Grid item xs={6} className={classes.bypass}>
              <FormControlLabel
                className={classes.formLabel}
                control={
                  <Switch
                    id="toggle-bypass-if-unavailable"
                    classes={{ colorSecondary: classes.switchChecked }}
                    size="small"
                    onChange={(_, checked) => {
                      setFieldValue('duo.bypass_if_unavailable', checked);
                    }}
                    checked={clientSelected?.duo?.bypass_if_unavailable}
                    name="bypass-if-unavailable"
                  />
                }
                label={
                  <Typography className={classes.switchText}>
                    {i18n.t('BYPASS_IF_UNAVAILABLE_KEY')}
                  </Typography>
                }
              />
              <Tooltip
                placement="top"
                arrow
                title={i18n.t('BYPASS_IF_UNAVAILABLE_DESCRIPTION_KEY')}
              >
                <InfoIcon fontSize="small" color="action" />
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ClientDUOConfig;
